import { Injectable } from '@angular/core';

import { AppUserClaimsService } from '../services/app-user-claims.service';
import { AppStateService } from '../services/app-state.service';
import { ClHeaderComponent } from '@mitel/cloudlink-console-components';
import { UserRoles } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsGuard {
  constructor(
    private appUserClaimsService: AppUserClaimsService,
    private appStateService: AppStateService,
    private clHeader: ClHeaderComponent
  ) { }

  canActivate(): boolean {
    let featureFlagsMode = this.appStateService.getFeatureFlagsMode();
    let claims = this.appUserClaimsService.getClaims();
    let assumed = this.appUserClaimsService.isAssumedRole();
    if (featureFlagsMode && claims.role === UserRoles.GLOBAL_ADMIN && !assumed) {
      console.log('Feature Flags Guard says: ', true);
      return true;
    } else {
      console.log('Feature Flags Guard says: ', false);
      this.clHeader.logoutUser();
      return false;
    }
  }
}